import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const ActionList = ({ children }: Props) => (
  <div className={'flex flex-row justify-center'}>{children}</div>
);

export default ActionList;
